function Logo({size}){
    return(
        <div className='title'>
                <h3 style={{fontSize: size? size : "30px"}}>Flee<span>xy</span></h3>
            </div>
    )
}

export default Logo